/** Header names the API layer reads or writes. One place, so a rename never misses a call site. */
export const HTTP_HEADERS = {
  accept: 'Accept',
  authorization: 'Authorization',
  /** Tells the CMPS BFF which portal the call comes from. */
  origin: 'x-origin-strategy',
  /** Correlates a browser request with server logs; echoed on `ApiError.requestId`. */
  requestId: 'X-Request-Id',
} as const;

/** Every failure the API layer can surface. Branch on `ApiError.kind`, never on raw status codes. */
export const ApiErrorKind = {
  /** No response at all (offline, DNS, CORS). */
  Network: 'network',
  /** The request exceeded `env.apiTimeoutMs`. */
  Timeout: 'timeout',
  /** Aborted through an `AbortSignal` (unmount, query key change). Never shown to users. */
  Canceled: 'canceled',
  /** 401 after the one silent token refresh, or no token could be acquired. */
  Unauthorized: 'unauthorized',
  /** 403: signed in but not allowed. */
  Forbidden: 'forbidden',
  NotFound: 'notFound',
  Conflict: 'conflict',
  /** 400 / 422 – field errors are in `ApiError.details`. */
  Validation: 'validation',
  /** HTTP 2xx, but the envelope said `success: false`. */
  Business: 'business',
  /** 5xx. */
  Server: 'server',
  /** Any other non-2xx status. */
  Http: 'http',
  /** A non-HTTP error that reached the API layer (programming error). */
  Unknown: 'unknown',
} as const;
export type ApiErrorKind = (typeof ApiErrorKind)[keyof typeof ApiErrorKind];

/** Kinds that are worth retrying automatically: the same request may succeed a moment later. */
export const RETRYABLE_ERROR_KINDS: readonly ApiErrorKind[] = [
  ApiErrorKind.Network,
  ApiErrorKind.Timeout,
  ApiErrorKind.Server,
];
